import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ACCOUNT } from '../constants';
import { Get, Post, Put, DeleteSingle } from '../../utils/httpProvider';
import { ACCOUNT_API, ACCOUNTAUTHINFO_API } from '../../utils/apiUrl.js';

export const accountPagingAction = createAsyncThunk(
    ACCOUNT.GET_PAGING,
    async (model) => {
        return Get(ACCOUNT_API.GET_PAGING_ACCOUNT, null, model)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);
export const accountAuthInfoPagingAction = createAsyncThunk(
    `${ACCOUNT.GET_PAGING}_AUTH_INFO`,
    async (model) => {
        return Get(ACCOUNTAUTHINFO_API.GET_PAGING, null, model)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);
export const addAccountAction = createAsyncThunk(
    ACCOUNT.ADD_ACCOUNT,
    async (model, { rejectWithValue }) => {
        try {
            const response = await Post(ACCOUNT_API.ADD_ACCOUNT, null, model, false);
            const text = await response.text();
            try {
                return text ? JSON.parse(text) : null;
            } catch (e) {
                return text;
            }
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const getByIdAccountAction = createAsyncThunk(
    ACCOUNT.GET_BY_ID_ACCOUNT,
    async (id) => {
        return Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, id, null)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);
export const getAccountAuthInfoByIdAccountAction = createAsyncThunk(
    ACCOUNT.GET_ACCOUNTAUTHINFO_BY_ID_ACCOUNT,
    async (id) => {
        return Get(ACCOUNTAUTHINFO_API.GET_ITEM, id, null)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);

export const updateAccountAuthInfoAction = createAsyncThunk(
    `${ACCOUNT.UPDATE_ACCOUNT_CONST}_AUTH_INFO`,
    async (model, { rejectWithValue }) => {
        try {
            const response = await Put(ACCOUNTAUTHINFO_API.UPDATE_ITEM, model.id, model.data);
            return response.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const getAccountInfoByIdAccountAction = createAsyncThunk(
    ACCOUNT.GET_ACCOUNTINFO_BY_ID_ACCOUNT,
    async (id) => {
        return Get(ACCOUNT_API.GET_ACCOUNT_INFO_BYID_FROM_APP_DUNGCHUNG, id, null)
            .then((response) => {
                return response;
            })
            .catch((error) => error);
    }
);
export const updateAccountAction = createAsyncThunk(
    ACCOUNT.UPDATE_ACCOUNT_CONST,
    async (model, { rejectWithValue }) => {
        try {
            const response = await Put(ACCOUNT_API.EDIT_ACCOUNT, model.id, model.data);
            return response.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
export const deleteAccountAction = createAsyncThunk(
    ACCOUNT.DELETE_ACCOUNT_CONST,
    async (id, { rejectWithValue }) => {
        try {
            const response = await DeleteSingle(ACCOUNT_API.DELETE_ACCOUNT, id, null);
            return response.status;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);
const initialState = {
    listAccount: [],
    totalAccount: 0,
    itemAccount: null,
    itemAccountAuthInfo: null,
    itemAccountInfo: null
};
export const accountSlice = createSlice({
    name: ACCOUNT.NAME_SLICE,
    initialState,
    reducers: {
        // filter lúc xóa bản ghi thành công
        filterListAccount: (state, action) => {
            state.listAccount =
                state.listAccount.length > 0
                    ? state.listAccount.filter((x) => x.id !== action.payload)
                    : [];
            state.totalAccount -= 1;
        },
        // cập nhật lại thông tin tài khoản trong local khi update
        reloadAccount: (state, action) => {
            const itemAccountNews = { ...state.itemAccount };
            itemAccountNews.fullName = action.payload.fullName;
            itemAccountNews.email = action.payload.email;
            state.itemAccount = itemAccountNews;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(accountPagingAction.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload) {
                    let rawData = payload.data !== undefined ? payload.data : (payload.Data !== undefined ? payload.Data : payload);
                    
                    if (rawData && rawData.$values) {
                        state.listAccount = rawData.$values;
                    } else if (Array.isArray(rawData)) {
                        state.listAccount = rawData;
                    } else {
                        state.listAccount = [];
                    }

                    state.totalAccount = payload.totalRecords !== undefined ? payload.totalRecords : 
                                       (payload.TotalRecords !== undefined ? payload.TotalRecords : 
                                       (Array.isArray(state.listAccount) ? state.listAccount.length : 0));
                } else {
                    state.listAccount = [];
                    state.totalAccount = 0;
                }
            })
            .addCase(accountAuthInfoPagingAction.fulfilled, (state, action) => {
                const payload = action.payload;
                if (payload) {
                    let rawData = payload.data !== undefined ? payload.data : (payload.Data !== undefined ? payload.Data : payload);
                    
                    if (rawData && rawData.$values) {
                        state.listAccount = rawData.$values;
                    } else if (Array.isArray(rawData)) {
                        state.listAccount = rawData;
                    } else {
                        state.listAccount = [];
                    }

                    state.totalAccount = payload.totalRecords !== undefined ? payload.totalRecords : 
                                       (payload.TotalRecords !== undefined ? payload.TotalRecords : 
                                       (Array.isArray(state.listAccount) ? state.listAccount.length : 0));
                } else {
                    state.listAccount = [];
                    state.totalAccount = 0;
                }
            })
            .addCase(getByIdAccountAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.itemAccount = action.payload;
                }
            })
            .addCase(getAccountAuthInfoByIdAccountAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.itemAccountAuthInfo = action.payload;
                }
            })
            .addCase(getAccountInfoByIdAccountAction.fulfilled, (state, action) => {
                if (action.payload) {
                    state.itemAccountInfo = action.payload;
                }
            })
            .addCase(getByIdAccountAction.rejected, (state) => {
                state.itemAccount = null;
            });
    }
});
export const { filterListAccount, reloadAccount } = accountSlice.actions;

export default accountSlice.reducer;
